//
// Site JS
// - No vendor JS
//

window.addEventListener(
    'load',
    function load()
    {
        window.removeEventListener('load', load, false);
        document.body.classList.remove('preload');
    },
    false);

// Init clipboard.js

var clipboard = new ClipboardJS('.btn--clipboard');
clipboard.on('success', function(e) {
    console.log(e);
    e.trigger.text("hello");
});
clipboard.on('error', function(e) {
    console.log(e);
});
